document.addEventListener('DOMContentLoaded', () => {
  // 1. Grab the <script> with product JSON
  const sectionDataEl = document.querySelector('script[data-section-type="static-product"]');
  if (!sectionDataEl) {
    console.warn("No static-product JSON found.");
    return;
  }

  const sectionData = JSON.parse(sectionDataEl.textContent);

  // 2. Pull out your main product data (for fallback) + extended variant data
  const productData = sectionData.product || {};
  const extendedVariants = sectionData.variants_with_desc || [];

  // 3. Helper to fetch the correct description
  //    - If variant's `variant_desc` is missing or blank, fall back to `product.description`
  function getVariantDescription(variantId) {
    if (!variantId) return productData.description || '';

    const match = extendedVariants.find(v => String(v.id) === String(variantId));
    const variantDesc = match?.metafields?.custom?.variant_desc?.trim();

    // If variantDesc is present and not just whitespace, use it; otherwise fallback:
    return variantDesc ? variantDesc : (productData.description || '');
  }

  // 4. Insert that description into .product-description
  function updateDescription(variantId) {
    const descEl = document.querySelector('.product-description');
    if (!descEl) {
      console.warn("No element '.product-description' found.");
      return;
    }
    descEl.innerHTML = getVariantDescription(variantId);
  }

  // 5. Read ?variant= from URL; if missing, use the first variant
  function onVariantChange() {
    const params = new URLSearchParams(window.location.search);
    let variantId = params.get('variant');

    if (!variantId && extendedVariants.length) {
      variantId = extendedVariants[0].id; // default to first variant
    }

    updateDescription(variantId);
  }

  // 6. Override pushState & replaceState to detect variant changes
  (function(history) {
    const originalPush = history.pushState;
    const originalReplace = history.replaceState;

    history.pushState = function(...args) {
      const ret = originalPush.apply(this, args);
      onVariantChange();
      return ret;
    };

    history.replaceState = function(...args) {
      const ret = originalReplace.apply(this, args);
      onVariantChange();
      return ret;
    };
  })(window.history);

  // 7. Listen for Back/Forward via popstate
  window.addEventListener('popstate', onVariantChange);

  // 8. Run once on page load
  onVariantChange();
});
